import { Helmet } from "react-helmet-async";
export default function Login() {
  return (
    <>
    <Helmet>
            <title>Login | MyApp</title>
          </Helmet>
    <div className="container py-4">
      <h1 className="mb-3">Login</h1>
      <p className="text-muted">We’ll implement this after registration.</p>
    </div>
    </>
  );
}
